import axios from 'axios';
// eslint-disable-next-line
import { NETWORK_SERVICES } from './networkRepository';

class NetworkFactory {
  constructor(service, config = {}) {
    if (service === NETWORK_SERVICES.AXIOS) {
      return this.setupAxios(config);
    }
    return null;
  }

  setupAxios = config => {
    const instance = axios.create({
      headers: { 'Content-Type': 'application/json; charset=UTF-8' },
      ...config
    });
    return instance;
  };
}

export default NetworkFactory;
